/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { IUniPickerCategory } from "@/types";

export const variables = {
  user: {
    label: "Benutzer",
    items: [
      { label: "Benutzer Id", value: "user_id" },
      { label: "Chat Id", value: "chat_id" },
      { label: "Anbieter Id", value: "provider_id" },
      { label: "Vorname", value: "first_name" },
      { label: "Nachname", value: "last_name" },
      { label: "Vollständiger Name", value: "full_name" },
      { label: "E-Mail-Adresse", value: "email" },
      { label: "Telefonnummer", value: "phone" },
      { label: "Zuerst gesehen", value: "signed_up" },
      { label: "Chat gestartet", value: "chat_started" },
      { label: "Zuletzt gesehen", value: "last_seen" },
      { label: "Sprache", value: "language" },
    ],
  },
  global: {
    label: "Global",
    items: [
      { label: "Id des Chatbots", value: "chatbot_id" },
      { label: "Name des Chatbots", value: "chatbot_name" },
      { label: "Aktueller Zeitstempel", value: "now" },
    ],
  },
  system: {
    label: "System",
    items: [
      {
        label: "Name des zuletzt geklickten Buttons",
        value: "last_clicked_button_name",
      },
      {
        label: "Id des zuletzt geklickten Buttons",
        value: "last_clicked_button_id",
      },
      {
        label: "Wert des zuletzt geklickten Buttons",
        value: "last_clicked_button_payload",
      },
      { label: "Id des zuletzt ausgeführten Blocks", value: "last_block_id" },
      {
        label: "Name des zuletzt ausgeführten Blocks",
        value: "last_block_name",
      },
      {
        label: "Anzahl verfügbarer Mitarbeiter im Posteingang",
        value: "available_employees_count",
      },
    ],
  },
} as { [key: string]: IUniPickerCategory };
